<script setup lang="ts">
import TopBarSection from '@/components/topbar-section/TopBarSection.component.vue'
import FooterSection from '@/components/footer-section/FooterSection.component.vue'
import { useThemeStore } from '@/components/theme-selector/themes-store'
import { getLcidFromRouteParams } from '@/pages-hooks/route-params'
import { getPageDataByRoute } from '@/pages-hooks'
const { path, params } = useRoute()
const pageData = getPageDataByRoute(path, params)
const homeData = <any>getPageDataByRoute('/', params)
const lcid = getLcidFromRouteParams(params)
useHead({
  htmlAttrs: {
    lang: lcid,
  },
})
useSeoMeta(
  getPageSEOInfo({
    lcid,
    title: pageData.title,
    description: pageData.description,
    path,
  }),
)

const refCurrentScrollY = ref(0)

onMounted(() => {
  if (import.meta.client && document) {
    useThemeStore().restoreTheme()
    window.addEventListener('scroll', () => (refCurrentScrollY.value = window.scrollY))
  }
})
</script>

<template>
  <div class="flex flex-col w-full flex-grow">
    <ClientOnly>
      <noscript>
        <strong
          >We're sorry but this website doesn't work properly without JavaScript enabled. Please enable it to
          continue.</strong
        >
      </noscript>
    </ClientOnly>
    <TopBarSection :lcid="lcid" :currentScrollY="refCurrentScrollY" />
    <NuxtPage :lcid="lcid" :pageData="pageData" :homeData="homeData" />
    <FooterSection :lcid="lcid" :homeData="homeData" />
  </div>
</template>
